
import { Vue, Component, Prop } from "vue-property-decorator";
import storage from "@/services/storage";
import DocumentProvider from "@/components/documents/DocumentProvider.vue";
import { Document, User } from "@/generated/graphql";
import MoreActions from "@/components/common/MoreActionsClick.vue";
import ConfirmRemovingDocumentModal from "@/components/documents/ConfirmRemovingDocumentModalNew.vue";
import Processing from "@/components/common/Processing.vue";
import splitFileNameExt from "@/utils/splitFileNameExt";
import SearchableListConfig from "@/entities/SearchableListConfig";
import searchableListConfig from "@/data/searchableListConfig";

@Component({
  components: {
    DocumentProvider,
    Processing,
    MoreActions,
    ConfirmRemovingDocumentModal,
  },
  // apollo: {
  //     update(data) {
  //       this.searchableListConfig.total = data.total.aggregate.count;
  //       this.searchableListConfig.loadedCount = data.document.length;
  //       return data.document;
  //     },
  //   },
})
export default class DocumentTable extends Vue {
  @Prop({ type: Object, required: true }) readonly documents!: Document[];
  @Prop({ type: Boolean, default: false }) readonly frozen!: boolean;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Boolean, default: false }) readonly extraInfoHidden!: boolean;
  @Prop({ type: String, default: undefined }) readonly customRequestId?: string;

  searchableListConfig: SearchableListConfig = { ...searchableListConfig };
  showModal : boolean = false;
  removeFunction: (() => void) | null = null;
  docuemntToRemove: null;

  removeDocument() {
    if (this.frozen) {
      return;
    }
     this.removeFunction();
  }

    deleteModal(document,remove){
    this.showModal = true;
    this.removeFunction = remove;
    this.docuemntToRemove = document;
    }

  isFrozen(document: Document): boolean {
    if (this.frozen) {
      return true;
    }

    if (this.currentUser.role === "ADMIN") {
      return false;
    }

    if (this.customRequestId) {
      return false;
    }

    return this.currentUser.id !== document.uploaded_by;
  }
  formatDate(dateToBeFormatted: string): string {
    const dateObj = new Date(dateToBeFormatted);

    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    const formattedDateString = dateObj.toLocaleDateString("en-US", options);

    return formattedDateString;
  }
  getDocumentSize(size) {
    size = (Number(size) / 1024).toFixed(1).replace(".0", "");

    return `${size} kB`;
  }

  async handleViewDocument(doc) {
    // Assuming document.url is the URL to view the document
    const documentUrl = doc;
    const splitName = splitFileNameExt(doc.filename!);
    const filename = `${splitName.name}-${doc.id}.${splitName.ext}`;
    const file = await this.getFile(filename);
    // Open the document in a new tab
    window.open(file, "_blank");
  }

  async getFile(filename: string) {
    return await storage
      .get(filename)
      .then((result: any) => result)
      .catch((err: any) => {
        throw err;
      });
  }
}
